import { useSelector } from 'react-redux';
import { PropsWithChildren, useEffect, useState } from 'react';

import { EventsState } from '../../../store/types';
import { EPermissions } from '../../../types/working-model';
import { userHasRoleOnActiveChannel } from '../../../utils/utils';

interface AuthWrapperProps {
	allowedRoles?: string[]
	blockedRoles?: EPermissions[];
}

const defaultAllowedRoles = [EPermissions.Owner, EPermissions.Admin, EPermissions.Builder];
const allRoles = Object.values(EPermissions);
export function AuthWrapper({ allowedRoles = [], blockedRoles = [], children }: PropsWithChildren<AuthWrapperProps>): JSX.Element {
	const hasPermission = useHasPermission({ allowedRoles, blockedRoles });

	if (hasPermission) {
		return <>{children}</>;
	}

	return <></>;
}

type HasPermissionProps = {
	allowedRoles?: string[];
	blockedRoles?: EPermissions[];
	anyExcept?: boolean;
}
export const useHasPermission = ({ allowedRoles = [], blockedRoles = [], anyExcept = false }: HasPermissionProps): boolean => {
	const user = useSelector((state: EventsState) => state.AuthReducer.user);
	const [hasPermission, setHasPermission] = useState<boolean>(false);

	useEffect(() => {
		const defaultAllowRoles = (anyExcept ? allRoles : defaultAllowedRoles).filter(role => !blockedRoles.includes(role));
		const hasRole = userHasRoleOnActiveChannel([...allowedRoles, ...defaultAllowRoles], user);
		setHasPermission(hasRole);
	}, [user, allowedRoles, blockedRoles, anyExcept]);

	return hasPermission;
};